/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';

/**
 * 
 * @export
 * @interface DailyOrderMetrics
 */
export interface DailyOrderMetrics {
    /**
     * 
     * @type {Date}
     * @memberof DailyOrderMetrics
     */
    day: Date;
    /**
     * 
     * @type {string}
     * @memberof DailyOrderMetrics
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof DailyOrderMetrics
     */
    orderCount: number;
    /**
     * 
     * @type {Amount}
     * @memberof DailyOrderMetrics
     */
    orderAmount: Amount;
    /**
     * 
     * @type {number}
     * @memberof DailyOrderMetrics
     */
    supplierCount: number;
    /**
     * 
     * @type {number}
     * @memberof DailyOrderMetrics
     */
    storeCount: number;
}

/**
 * Check if a given object implements the DailyOrderMetrics interface.
 */
// @ts-ignore
export function instanceOfDailyOrderMetrics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "day" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "orderCount" in value;
    isInstance = isInstance && "orderAmount" in value;
    isInstance = isInstance && "supplierCount" in value;
    isInstance = isInstance && "storeCount" in value;

    return isInstance;
}

// @ts-ignore
export function DailyOrderMetricsFromJSON(json: any): DailyOrderMetrics {
    return DailyOrderMetricsFromJSONTyped(json, false);
}

// @ts-ignore
export function DailyOrderMetricsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyOrderMetrics {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'day': (new Date(json['day'])),
        'currencyCode': json['currency_code'],
        'orderCount': json['order_count'],
        'orderAmount': AmountFromJSON(json['order_amount']),
        'supplierCount': json['supplier_count'],
        'storeCount': json['store_count'],
    };
}

// @ts-ignore
export function DailyOrderMetricsToJSON(value?: DailyOrderMetrics | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'day': (value.day.toISOString().substring(0,10)),
        'currency_code': value.currencyCode,
        'order_count': value.orderCount,
        'order_amount': AmountToJSON(value.orderAmount),
        'supplier_count': value.supplierCount,
        'store_count': value.storeCount,
    };
}

